<contact-edit [model]="model | async" [isNew]="isNew" (onSave)="saveContact($event)" (onCancel)="cancel()"></contact-edit>
